/* Earrings configurator — behaviour for sections/earrings-configurator.liquid.
   Product options: 1 = Carat, 2 = Colour, 3 = Gold. The Figma design shows ONE
   "Metal" grid, so colour and gold are picked together by a single card
   ([data-metal-card] with data-colour / data-gold) while the product keeps both
   options — Broadcast's collection cards need the Colour option to draw swatches. */
(function () {
  var section = document.querySelector('[data-earrings-configurator]');
  if (!section) return;

  var $ = function (s, r) { return (r || section).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || section).querySelectorAll(s)); };

  var variants = [], cfg = {};
  try { variants = JSON.parse($('[data-variant-json]').textContent); } catch (e) { variants = []; }
  try { cfg = JSON.parse($('[data-config]').textContent); } catch (e) { cfg = {}; }

  var form = $('form.ecfg__form');
  var variantInput = $('[data-variant-id]');
  var priceEl = $('[data-price]');
  var dockPrice = $('[data-dock-price]');
  var dockSub = $('[data-dock-sub]');
  var addButton = $('[data-add-button]');
  var addText = $('[data-add-text]');
  var availability = $('[data-availability]');
  var summaryCarat = $('[data-summary-carat]');
  var summaryEach = $('[data-summary-each]');
  var summaryMetal = $('[data-summary-metal]');
  var summaryThumb = $('[data-summary-thumb]');

  // ---- money: whole units, no cents, narrow symbol (€530, kr 5 160) ----
  function money(cents, signed) {
    var n = Math.round(cents / 100), s;
    try {
      s = new Intl.NumberFormat(cfg.locale || document.documentElement.lang || 'en', {
        style: 'currency', currency: cfg.currency || 'EUR', currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0, minimumFractionDigits: 0
      }).format(Math.abs(n));
    } catch (e) { s = Math.abs(n) + ' ' + (cfg.currency || ''); }
    if (!signed) return s;
    return n === 0 ? s : (n > 0 ? '+ ' : '– ') + s;
  }

  // ---- selection state: carat from the option cards, colour+gold from the metal card ----
  function selected(pos) {
    if (pos === 1) {
      var on = $('[data-option-card][data-option-position="1"][aria-checked="true"]');
      return on ? on.getAttribute('data-option-value') : null;
    }
    var m = $('[data-metal-card][aria-checked="true"]');
    if (!m) return null;
    return pos === 2 ? m.getAttribute('data-colour') : m.getAttribute('data-gold');
  }
  function setChecked(pos, value) {
    if (pos === 1) {
      $$('[data-option-card][data-option-position="1"]').forEach(function (c) {
        c.setAttribute('aria-checked', c.getAttribute('data-option-value') === value ? 'true' : 'false');
      });
      return;
    }
    var colour = pos === 2 ? value : selected(2);
    var gold = pos === 3 ? value : selected(3);
    setMetal(colour, gold);
  }
  function setMetal(colour, gold) {
    $$('[data-metal-card]').forEach(function (c) {
      var on = c.getAttribute('data-colour') === colour && c.getAttribute('data-gold') === gold;
      c.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  function find(o1, o2, o3) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if ((o1 == null || v.option1 === o1) && (o2 == null || v.option2 === o2) && (o3 == null || v.option3 === o3)) return v;
    }
    return null;
  }
  function exists(o1, o2, o3) { return !!find(o1, o2, o3); }

  // ---- carat → mm (round brilliant); fancy shapes are handled by the note ----
  var MM = { '0.15': 3.4, '0.25': 4.1, '0.3': 4.3, '0.4': 4.8, '0.46': 4.9, '0.5': 5.1, '0.7': 5.7, '0.75': 5.8, '1': 6.4, '1.25': 6.9, '1.5': 7.4, '2': 8.1, '2.5': 8.8, '3': 9.3 };
  function caratNum(label) { var m = String(label).match(/[\d.]+/); return m ? parseFloat(m[0]) : NaN; }
  function mmFor(label) {
    var c = caratNum(label); if (isNaN(c)) return null;
    // With per-pair values each stone is half the stated weight.
    if (cfg.caratBasis === 'pair') c = c / 2;
    var key = String(c);
    if (MM[key]) return MM[key];
    return Math.round(6.4 * Math.cbrt(c) * 10) / 10;       // diameter grows with the cube root of weight
  }
  function feelsLike(c) {
    if (cfg.caratBasis === 'pair') c = c / 2;
    if (c < 0.4) return 'Subtle, everyday';
    if (c < 0.9) return 'Classic';
    if (c < 1.4) return 'Noticeable';
    if (c < 1.9) return 'Statement';
    return 'Bold';
  }
  function fmtCt(n) {
    if (isNaN(n)) return '';
    return (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '') + ' ct';
  }

  // ---- gallery ----
  var slides = $$('[data-slide]'), dots = $$('[data-dot]'), thumbs = $$('[data-thumb]');
  function showSlide(i) {
    if (!slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    var active = thumbs[i]; if (active && active.scrollIntoView) { try { active.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
  }
  dots.concat(thumbs).forEach(function (b) { b.addEventListener('click', function () { showSlide(parseInt(b.getAttribute('data-index'), 10)); }); });
  var stage = $('[data-stage]');
  if (stage) {
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) < 40) return;
      var cur = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      showSlide(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }
  function showVariantMedia(v) {
    if (!v || !v.mediaId) return;
    var idx = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(v.mediaId); });
    // Picking a metal shows that colour's photo, in the gallery and in the selection card.
    if (idx > -1) {
      showSlide(idx);
      if (summaryThumb) {
        var img = slides[idx].querySelector('img');
        if (img && img.currentSrc) summaryThumb.src = img.currentSrc;
      }
    }
  }

  // ---- render everything from the current selection ----
  function updateCaratPrices() {
    var colour = selected(2), gold = selected(3);
    $$('[data-carat-price]').forEach(function (el) {
      var carat = el.getAttribute('data-carat-price');
      var v = find(carat, colour, gold) || find(carat, colour, null) || find(carat, null, null);
      var card = el.closest('[data-option-card]');
      if (v) { el.textContent = money(v.price); card.classList.remove('is-unavailable'); card.removeAttribute('aria-disabled'); }
      else { el.textContent = '—'; card.classList.add('is-unavailable'); card.setAttribute('aria-disabled', 'true'); }
    });
  }
  function updateMetalDeltas() {
    var carat = selected(1), colour = selected(2), gold = selected(3);
    var base = find(carat, colour, gold);
    $$('[data-metal-delta]').forEach(function (el) {
      var parts = el.getAttribute('data-metal-delta').split('|');
      var v = find(carat, parts[0], parts[1]) || find(null, parts[0], parts[1]);
      var card = el.closest('[data-metal-card]');
      if (!v) { el.textContent = '—'; card.classList.add('is-unavailable'); return; }
      card.classList.remove('is-unavailable');
      if (parts[0] === colour && parts[1] === gold) el.textContent = 'Selected';
      else el.textContent = base ? money(v.price - base.price, true) : money(v.price);
    });
  }

  function update() {
    var o1 = selected(1), o2 = selected(2), o3 = selected(3);
    var v = find(o1, o2, o3);
    updateCaratPrices(); updateMetalDeltas();

    if (summaryCarat) summaryCarat.textContent = o1 || '';
    if (summaryEach) {
      var c = caratNum(o1);
      summaryEach.textContent = (cfg.caratBasis === 'pair' && !isNaN(c))
        ? fmtCt(c / 2).replace(' ct', '') + ' ' + (cfg.eachSuffix || 'ct/earring') : '';
    }
    var metalLabel = [o3, o2 ? o2.replace(' gold', ' Gold') : ''].filter(Boolean).join(' ');
    if (summaryMetal) summaryMetal.textContent = metalLabel;
    if (dockSub) dockSub.textContent = [cfg.title, o1, metalLabel].filter(Boolean).join(' · ');

    if (!v) {
      variantInput.value = '';
      addButton.disabled = true; addText.textContent = 'Unavailable';
      availability.textContent = 'This combination is not available — try another metal or carat.';
      return;
    }
    variantInput.value = v.id;
    var p = money(v.price);
    if (priceEl) priceEl.textContent = p;
    if (dockPrice) dockPrice.textContent = p;
    addButton.disabled = !v.available;
    addText.textContent = v.available ? (cfg.addLabel || 'Add to cart') : 'Unavailable';
    availability.textContent = v.available ? '' : 'Currently unavailable in this combination.';
    showVariantMedia(v);
    // keep the URL shareable (?variant=), without adding history entries
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
  }

  // ---- clicks: carat cards and metal cards; auto-repair impossible combinations ----
  section.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var metal = e.target.closest('[data-metal-card]');
    if (metal && section.contains(metal)) {
      var colour = metal.getAttribute('data-colour'), gold = metal.getAttribute('data-gold');
      setMetal(colour, gold);
      if (!exists(selected(1), colour, gold)) {
        var fixM = find(null, colour, gold);
        if (fixM) setChecked(1, fixM.option1);
      }
      update();
      return;
    }
    var card = e.target.closest('[data-option-card]');
    if (!card || !section.contains(card)) return;
    var val = card.getAttribute('data-option-value');
    setChecked(1, val);
    if (!exists(val, selected(2), selected(3))) {
      // Keep the carat the shopper just touched; relax the metal.
      var fix = find(val, selected(2), null) || find(val, null, null);
      if (fix) setMetal(fix.option2, fix.option3);
    }
    update();
  });

  // ---- add to bag: hand off to Broadcast, exactly like the bracelet configurator ----
  // Broadcast's <product-form> already intercepts submit and dispatches
  // `theme:cart:add` (theme.js onSubmitHandler). Dispatching it again here would
  // add the item twice, so only do it when the element is NOT defined (fallback).
  if (form && !customElements.get('product-form')) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addButton.disabled) return;
      document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: addButton }, bubbles: false }));
      if (window.a11y) window.a11y.lastElement = addButton;
    });
  }

  // ---- sticky buy dock on mobile (same approach as the bracelets) ----
  var buySlot = $('[data-buy-slot]'), buyDock = $('[data-buy-dock]');
  var mq = window.matchMedia('(max-width: 749px)'), frame = 0;
  function updateDock() {
    frame = 0;
    if (!buySlot || !buyDock) return;
    if (!mq.matches) { buyDock.classList.remove('is-fixed'); buySlot.style.removeProperty('height'); liftLaunchers(0); return; }
    buySlot.style.height = buyDock.offsetHeight + 'px';          // reserve space so nothing jumps
    var fixed = buySlot.getBoundingClientRect().bottom > window.innerHeight;
    buyDock.classList.toggle('is-fixed', fixed);
    liftLaunchers(fixed ? buyDock.offsetHeight : 0);
  }
  // Third-party launchers float over the sticky dock on mobile: Shopify Inbox's "Support"
  // button (bottom-right, host <shopify-chat> is a full-viewport fixed grid whose launcher
  // sits at its bottom edge) and Klaviyo's teaser (fixed bottom-left). While the dock is
  // fixed, lift both above it; the open chat panel is positioned on its own and unaffected.
  function liftLaunchers(px) {
    var targets = [document.querySelector('shopify-chat')].concat(
      $$('[class*="kl-teaser"]', document).filter(function (e) { return getComputedStyle(e).position === 'fixed'; }));
    targets.forEach(function (el) {
      if (!el) return;
      if (px) el.style.setProperty('bottom', (px + 8) + 'px', 'important'); else el.style.removeProperty('bottom');
    });
  }
  function scheduleDock() { if (!frame) frame = requestAnimationFrame(updateDock); }
  window.addEventListener('scroll', scheduleDock, { passive: true });
  window.addEventListener('resize', scheduleDock);
  if (mq.addEventListener) mq.addEventListener('change', scheduleDock);
  if ('ResizeObserver' in window && buyDock) new ResizeObserver(scheduleDock).observe(buyDock);
  // the chat launcher and the Klaviyo teaser are injected late — re-run once they exist
  window.addEventListener('load', scheduleDock);
  setTimeout(scheduleDock, 1500); setTimeout(scheduleDock, 4000);

  // ---- ear size guide ----
  var modal = $('[data-size-guide]'), stone = $('[data-ear-stone]'), earCarat = $('[data-ear-carat]'), earMm = $('[data-ear-mm]'), earTable = $('[data-ear-table]');
  var PX_PER_MM = 3.4;                                             // 6.4 mm ≈ 22 px on the 200×260 ear drawing
  var lastFocus = null;
  function pickEar(label) {
    var mm = mmFor(label); if (!mm || !stone) return;
    var r = (mm * PX_PER_MM) / 2;
    // fancy shapes of the same weight read a touch wider face-up
    if (cfg.shape && /pear|oval|emerald|princess|marquise/.test(cfg.shape)) r *= 1.05;
    stone.setAttribute('r', r.toFixed(1));
    earCarat.textContent = label; earMm.textContent = mm;
    $$('[data-ear-pick]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-ear-pick') === label); });
    $$('tr', earTable).forEach(function (tr) { tr.classList.toggle('is-active', tr.getAttribute('data-carat') === label); });
  }
  function buildTable() {
    if (!earTable) return;
    earTable.innerHTML = $$('[data-ear-pick]').map(function (b) {
      var label = b.getAttribute('data-ear-pick'), c = caratNum(label), mm = mmFor(label);
      return '<tr data-carat="' + label.replace(/"/g, '&quot;') + '"><td>' + label + '</td><td>' + (mm ? '≈ ' + mm + ' mm' : '—') + '</td><td>' + feelsLike(c) + '</td></tr>';
    }).join('');
  }
  function openGuide() {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false; document.documentElement.classList.add('ecfg-modal-open');
    pickEar(selected(1) || ($('[data-ear-pick]') || {}).getAttribute('data-ear-pick'));
    var close = $('.ecfg__modal-close', modal); if (close) close.focus();
    document.addEventListener('keydown', onKey, true);
  }
  function closeGuide() {
    if (!modal) return;
    modal.hidden = true; document.documentElement.classList.remove('ecfg-modal-open');
    document.removeEventListener('keydown', onKey, true);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeGuide(); return; }
    if (e.key !== 'Tab' || !modal) return;
    var f = $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', modal).filter(function (el) { return !el.disabled; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  $$('[data-size-guide-open]').forEach(function (b) { b.addEventListener('click', openGuide); });
  $$('[data-size-guide-close]').forEach(function (b) { b.addEventListener('click', closeGuide); });
  $$('[data-ear-pick]').forEach(function (b) { b.addEventListener('click', function () { pickEar(b.getAttribute('data-ear-pick')); }); });
  buildTable();

  // ---- boot ----
  update();
  updateDock();
})();
